export default __webpack_public_path__ + "static/media/Canal_Promessas.a8206a97.png";